
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireforoutstation() {



    const cardData =
    {
        keyword: 'Bus Hire for Outstation',
        heading: 'Amruta Travels: Bus Hire for Outstation',
        headingDescription: 'Amruta Travels offers Bus Hire for Outstation in Pune, providing reliable, comfortable, and hassle-free transportation solutions for long-distance journeys. Whether you are planning a pilgrimage, family vacation, corporate retreat, or group tour, our well-maintained fleet ensures a smooth and enjoyable ride. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make outstation travel simple and stress-free. Choose from our range of buses, including 32-seater, 35-seater, 45-seater, and 50-seater options, to suit your group size. Book your outstation bus with Amruta Travels and embark on a journey of comfort and convenience!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],

   "services": [
    {
      "name": "Mini Bus Booking for Outstation",
      "description": "Looking for a mini bus for your outstation trip? Amruta Travels offers mini bus booking services for group travel to nearby and distant destinations. Whether you’re planning a family getaway or a corporate retreat, our mini buses provide comfort, safety, and affordability for your journey."
    },
    {
      "name": "Hire Bus for Outstation in Hadapsar",
      "description": "If you're located in Hadapsar and need to hire a bus for an outstation trip, Amruta Travels is here to help. We provide comfortable and reliable buses for both short and long-distance travel, ensuring you have a hassle-free journey with professional drivers and clean, well-maintained buses."
    },
    {
      "name": "Outstation Mini Bus Hire",
      "description": "For your next outstation trip, consider hiring a mini bus from Amruta Travels. Our outstation mini buses are ideal for group travel, offering ample seating and air conditioning. Whether it's a pilgrimage or a sightseeing tour, our mini buses ensure a comfortable and enjoyable journey."
    },
    {
      "name": "Mini Bus on Rent for Outstation in Pune",
      "description": "Rent a mini bus from Amruta Travels for your outstation trip from Pune. Our fleet includes well-maintained mini buses with options for AC and non-AC. Whether it's a trip to Shirdi, Lonavala, or any other destination, we ensure a smooth and enjoyable ride with flexible schedules."
    },
    {
      "name": "Hire a Bus for Outstation Pune to Shirdi",
      "description": "Planning a pilgrimage to Shirdi? Hire a bus from Amruta Travels for a comfortable journey from Pune to Shirdi. Our buses are equipped with modern amenities and driven by experienced chauffeurs, ensuring your group travels in comfort and safety to this spiritual destination."
    },
    {
      "name": "Mini Bus for Outstation from Kharadi",
      "description": "For outstation trips starting from Kharadi, Amruta Travels offers mini bus rentals that are perfect for group travel. Whether you're heading to nearby attractions or distant destinations, our buses provide a comfortable, air-conditioned ride with professional drivers for a seamless experience."
    },
    {
      "name": "Book Bus for Outstation",
      "description": "Booking a bus for an outstation trip is easy with Amruta Travels. Our buses are available for a wide range of destinations, from religious tours to leisure trips. With options for various seating capacities and air-conditioned comfort, we make sure you enjoy a safe and pleasant journey."
    },
    {
      "name": "Outstation Bus Hire in Baner",
      "description": "If you're located in Baner and need a bus for an outstation trip, Amruta Travels offers reliable bus hire services. Our fleet includes mini buses, 17-seaters, and larger buses for all your group travel needs. Enjoy a hassle-free journey with professional drivers and top-notch service."
    },
    {
      "name": "Mini Bus Booking for Outstation",
      "description": "Amruta Travels provides mini bus booking services for outstation trips. Whether you’re heading for a weekend getaway or a longer holiday, our mini buses ensure comfort and affordability for group travel. We offer a variety of options for different group sizes and destinations."
    },
    {
      "name": "Mini Bus Booking Near Me",
      "description": "Looking to book a mini bus near you? Amruta Travels offers mini bus booking services across Pune and nearby areas. Whether it's for a short trip or an outstation journey, we provide reliable and cost-effective options for your group travel needs."
    },
    {
      "name": "Kalyani Nagar to Outstation Bus Hire",
      "description": "For those in Kalyani Nagar, Amruta Travels offers outstation bus hire services for all types of trips. Our buses are well-maintained, comfortable, and ideal for group travel. Whether you're going for a spiritual trip, vacation, or corporate outing, we ensure a smooth and enjoyable ride."
    },
    {
      "name": "14, 17, 25, 32 Seater Hire for Outstation Trip",
      "description": "Amruta Travels provides a variety of seating options for outstation trips. Whether you need a 14-seater for a small group or a larger 32-seater for bigger groups, we have the perfect bus for you. Our buses are comfortable, clean, and equipped with everything you need for a long journey."
    },
    {
      "name": "35, 40, 45, 50 Seater Hire for Outstation from Pune",
      "description": "Amruta Travels offers a fleet of large buses, including 35, 40, 45, and 50-seater options, for outstation travel from Pune. Whether it’s a family trip, corporate outing, or group tour, our buses ensure a comfortable ride with plenty of space, modern amenities, and professional drivers."
    },
    {
      "name": "Pune to Ajanta Ellora Caves Bus Tour",
      "description": "Explore the historic Ajanta Ellora Caves with Amruta Travels’ bus tour service from Pune. Our buses are designed for comfort and ease, offering a smooth ride to these UNESCO World Heritage sites. Whether it’s a family trip or a school excursion, we ensure a memorable experience."
    },
    {
      "name": "AC 17 Seater Bus on Rent in Pune",
      "description": "Rent a comfortable AC 17-seater bus for your group’s next outstation trip with Amruta Travels. Perfect for smaller groups, our 17-seater buses provide air-conditioned comfort, spacious seating, and safe, reliable travel for any destination, including weekend getaways and corporate trips."
    }
  ],
  "tableData": [
    ["Mini Bus Booking for Outstation", "Hire Bus for Outstation in Hadapsar"],
    ["Outstation Mini Bus Hire", "Mini Bus on Rent for Outstation in Pune"],
    ["Hire a Bus for Outstation Pune to Shirdi", "Mini Bus for Outstation from Kharadi"],
    ["Book Bus for Outstation", "Outstation Bus Hire in Baner"],
    ["Mini Bus Booking for Outstation", "Mini Bus Booking Near Me"],
    ["Kalyani Nagar to Outstation Bus Hire", "14, 17, 25, 32 Seater Hire for Outstation Trip"],
    ["35, 40, 45, 50 Seater Hire for Outstation from Pune", "Pune to Ajanta Ellora Caves Bus Tour"],
    ["AC 17 Seater Bus on Rent in Pune", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable Long-Distance Travel",
    "WhyChoosedescription": "Amruta Travels offers Bus Hire for Outstation, providing comfortable and air-conditioned buses for long-distance journeys. Whether it’s a weekend getaway or a business trip, we ensure a smooth ride."
  },
  {
    "WhyChooseheading": "Perfect for Group Travel",
    "WhyChoosedescription": "Our buses are ideal for family vacations, corporate trips, religious pilgrimages, or group tours. We accommodate large groups comfortably, making outstation travel more enjoyable."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Travel",
    "WhyChoosedescription": "Our professional drivers are experienced in long-distance routes, ensuring safe, timely, and hassle-free travel. They are knowledgeable about all outstation routes, guaranteeing a reliable journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer competitive pricing for Bus Hire for Outstation trips, with no hidden charges. Our transparent pricing lets you plan your trip without worrying about unexpected costs."
  },
  {
    "WhyChooseheading": "Well-Maintained Buses for Peace of Mind",
    "WhyChoosedescription": "All our buses are regularly maintained and thoroughly inspected before each outstation journey. You can travel with peace of mind, knowing your vehicle is in excellent condition."
  },
  {
    "WhyChooseheading": "Flexible Routes and Customizable Schedules",
    "WhyChoosedescription": "We offer flexible routes and schedules tailored to your needs. Whether it’s a direct route or multiple stopovers, we customize the itinerary to match your outstation travel plans."
  },
  {
    "WhyChooseheading": "24/7 Availability for Outstation Trips",
    "WhyChoosedescription": "Our Bus Hire for Outstation service is available 24/7, ensuring that you can book your trip at any time. We work around your schedule to make your journey as convenient as possible."
  },
  {
    "WhyChooseheading": "Simple Booking Process with Full Support",
    "WhyChoosedescription": "Booking a bus for your outstation trip with Amruta Travels is easy and quick. Our customer support team is always ready to assist with your booking, route planning, and any other inquiries."
  }
]




























    }

const faqData = [
  {
    question: 'How can I hire a bus for an outstation trip with Amruta Travels?',
    answer: 'Hiring a bus for an outstation trip with Amruta Travels is easy. You can book online, call our support team, or visit our office. We will assist you in selecting the right bus based on your destination, group size, and trip duration.',
  },
  {
    question: 'What types of buses are available for outstation travel?',
    answer: 'We offer a variety of buses for outstation travel, including 32, 35, 45, and 50 seater options. All our buses are equipped with comfortable seating, air conditioning, and ample luggage space, ensuring a comfortable journey for your group.',
  },
  {
    question: 'Are the buses suitable for long-distance outstation trips?',
    answer: 'Yes, our buses are ideal for long-distance outstation trips. Whether you’re traveling for a few hours or several days, our buses provide comfort, safety, and a smooth ride for all passengers.',
  },
  {
    question: 'Do you provide buses for weekend getaways and long tours?',
    answer: 'Yes, we provide buses for both short weekend getaways and long outstation tours. Whether it’s a day trip or an extended holiday, we ensure you travel comfortably and safely to your destination.',
  },
  {
    question: 'Are the buses well-maintained and sanitized for outstation trips?',
    answer: 'Absolutely! All our buses are regularly maintained and thoroughly sanitized before every outstation trip. We prioritize passenger safety, cleanliness, and comfort for every journey.',
  },
  {
    question: 'How much does it cost to hire a bus for an outstation trip?',
    answer: 'The cost of hiring a bus for an outstation trip depends on the type of bus, the distance, and the duration of your journey. Contact us with your trip details for a customized and transparent quote.',
  },
  {
    question: 'Do you provide experienced drivers for outstation trips?',
    answer: 'Yes, all outstation bus rentals come with experienced and licensed drivers. Our drivers are familiar with long-distance travel and are committed to ensuring safety, punctuality, and a smooth ride.',
  },
  {
    question: 'Can I request multiple pickup and drop-off points for an outstation trip?',
    answer: 'Yes, we offer flexible routing with multiple pickup and drop-off points for your outstation trip. Simply share your itinerary with us, and we will plan the best route to suit your travel needs.',
  },
  {
    question: 'Why choose Amruta Travels for outstation bus hire?',
    answer: 'Amruta Travels offers reliable, professional service with well-maintained buses, skilled drivers, and a focus on customer satisfaction. We ensure a smooth and enjoyable outstation travel experience for all our customers.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sanjay Jadhav',
    role: 'Corporate Travel Manager, Pune',
    text: 'We hired a 45-seater bus from Amruta Travels for an outstation corporate trip to Mumbai. The bus was comfortable, the driver was experienced, and the entire journey was smooth. I highly recommend their service for outstation travel.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Vandana Shah',
    role: 'Tour Organizer, Pune',
    text: 'Amruta Travels provided a 50-seater bus for our family’s outstation trip to Mahabaleshwar. The bus was clean, spacious, and comfortable. The driver was friendly and made the trip enjoyable. We’ll definitely use their services again for our future trips.',
    rating: 5,
  },
];






































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Outstation",
  "image": "https://bushireinpune.com/assets/images/bus-hire-for-outstation.jpg",
  "description": "Book mini buses or large buses for outstation trips from Pune with Amruta Travels. We offer buses for trips to Shirdi, Ajanta Ellora Caves, and other outstation destinations. Choose from 14, 17, 25, 32, 35, 40, 45, and 50-seater options for your outstation travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5623"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "50", // Adjust based on per km or flat rate for outstation bus rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-hire-for-outstation"
  }
};





    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Bus Hire for Outstation | Outstation Bus Rentals from Pune | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book buses for outstation trips from Pune to Shirdi, Ajanta Ellora Caves, and other destinations with Amruta Travels. Rent mini buses, 17-seater, 32-seater, and larger buses for outstation travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/15.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireforoutstation;